<template>
  <header class="c-header">
    <div class="c-logo"><router-link to="/"><img src="../assets/images/callio.svg" alt="logo"></router-link></div>
    <!-- Menu-->
    <div class="c-menu">
      <ul>
        <template v-for="item in menuItems">
          <router-link v-if="item.href && checkRole(item.roles) && !item.disabled" :key="item.href" :to="item.href"
                       v-slot="{ href, navigate, isActive, isExactActive }">
            <li :class="[isActive ?'active':'',item.items?'li-submenu':'','li-border-none']">
              <a :href="href" @click="navigate">
                <img class="c-menu-icon" :src="item.icon" :alt="item.name">
                <span class="c-menu-text">{{ item.name }}</span>
                <span v-if="item.items" class="btn-submenu"></span>
              </a>
              <div class="dropdown-menu is-custom" v-if="item.items && checkRole(item.roles) && !item.disabled"
                   :key="item.name">
                <div class="dropdown-menu__inner">
                  <ul class="ul-list">
                    <router-link v-for="i in item.items" :key="i.href" :to="i.href"
                                 v-slot="{ href, navigate, isExactActive }">
                      <li class="li-icon" v-if="checkRole(i.roles) && !i.disabled">
                        <a :class="[isExactActive ?'active':'','treeview-item']" :href="href" @click="navigate">
                          <i :class="i.icon"></i>{{ i.name }}
                        </a>
                      </li>
                    </router-link>
                  </ul>
                </div>
              </div>
            </li>
          </router-link>
        </template>
        <li class="li-submenu li-more">
          <a href="javascript:;"><img class="c-menu-icon" src="../assets/images/icons/icon-more.svg" alt="more"><span
              class="c-menu-text">{{ $t('seeMore') }}</span><span class="btn-submenu"></span></a>
          <div class="dropdown-menu is-custom dropdown-menu-right">
            <div class="dropdown-menu__inner">
              <ul class="ul-list">
                <li class="li-dot">
                  <router-link to="/history">{{ $t('callHistory') }}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- search-->
    <div class="c-search">
      <div class="c-search__inner">
        <input class="form-control" type="text" :placeholder="$t('quickSearch')">
        <button class="c-search__btn" type="submit"><i class="icon16-search-gadient"></i></button>
        <button class="c-search__close js-search-hide" type="button"><i class="icon16-cancel-primary"></i>
        </button>
      </div>
    </div>
    <!--header right-->
    <div class="c-menu-right">
      <ul>
        <li class="li-avatar dropdown">
          <a class="dropdown-toggle" href="javascript:;" data-toggle="dropdown">
            <figure class="c-avatar">{{ getAvatar() }}</figure>
            <span class="c-avatar-name">
              <span class="normal">{{ $store.state.user.name }}</span>
              <span class="small">{{ $store.state.user.client.companyName }}</span>
            </span>
          </a>
          <div class="dropdown-menu is-custom dropdown-menu-right">
            <div class="dropdown-menu__inner">
              <ul class="ul-list">

                <li class="c-line-gadient"></li>
                <li class="li-icon">
                  <router-link to="/setting"><i class="icon16-setting-primary"></i>{{ $t('settings') }}</router-link>
                </li>
                <li class="li-icon">
                  <a href="javascript:;" @click="update">
                  <i class="icon16-update-primary"></i>{{ $t('updateCallio') }}</a>
                </li>
                <li class="li-icon">
                  <a href="javascript:;" @click="support()">
                    <i class="icon16-support-primary"></i>{{ $t('support') }}
                  </a>
                </li>
                <li class="li-icon">
                  <a href="javascript:;" onclick="Tawk_API.toggle()">
                    <i class="icon16-support-primary"></i>{{ $t('support') }}
                  </a>
                </li>
                <li class="c-line-gadient"></li>
                <li class="li-icon">
                  <a href="javascript:;" @click="logout"><i class="icon16-logout-primary"></i>{{ $t('logout') }}</a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <phone-status></phone-status>
        <li class="d-md-none">
          <a class="c-menu-expand js-menu-expand" href="javascript:;"><img src="../assets/images/icons/icon-bars.svg" alt="bars"></a>
        </li>
      </ul>
    </div>
    <pop-up-ket-doi ref="popup"></pop-up-ket-doi>
  </header>
</template>

<script>
import PhoneStatus from "./PhoneStatus";
import $ from 'jquery';
import console from 'console';
import PopUpKetDoi from "@/views/PopUpKetDoi";

export default {
  components: {PopUpKetDoi, PhoneStatus},
  data () {
    return {
      token: localStorage.getItem('token')
    };
  },
  computed: {
    menuItems: function () {
      let items = [];
      items.push(
          {name: this.$t('inbox'), href: '/inbox', icon: require('../assets/images/icons/icon-inbox.svg')}
      );
      if (this.$store.state.user.client._id !== '610105a385dd35224504e735') {
        items.push({
          name: this.$t('contacts'),
          href: '/contact',
          icon: require('../assets/images/icons/icon-opportunities.svg'),
          items: [
            {
              name: 'Danh sách bệnh nhân',
              href: '/contact/benh-nhan',
              icon: 'icon16-contact-book-2-primary'
            },
            {
              name: 'Danh sách BS, TNV',
              href: '/contact/internal',
              icon: 'icon16-contact-book-primary'
            },
            {
              name: 'Danh sách cặp BS - TNV',
              href: '/contact/nhom-nvyt',
              icon: 'icon16-contact-book-primary'
            },
          ]
        })
      }
      if (this.$store.state.user.permissions.includes('issueEnabled')) {
        items.push({
          name: 'Phản ánh của người dân', href: '/issue', icon: require('../assets/images/icons/icon-inbox.svg')
        })
      }
      items.push({
        name: this.$t('reports'),
        href: '/report',
        icon: require('../assets/images/icons/icon-report.svg')
      });
      return items
    }
  },
  methods: {
    checkRole: function (roles) {
      if (!roles || roles.length === 0) {
        return true;
      }
      if (roles.find(role => this.$store.state.user.role === role)) {
        return true;
      }
      return false;
    },
    logout: function () {
      if (window.webkit && window.webkit.messageHandlers.iOSNative) {
        window.webkit.messageHandlers.iOSNative.postMessage({
          type: 'disconnect'
        });
      }
      if (window.androidNative) {
        window.androidNative.postMessage(JSON.stringify({
          type: 'disconnect'
        }));
      }
      this.$store.dispatch('logout').finally(()=>{
        location.href = '#/login';
      });
    },
    getAvatar: function () {
      let avatar = '';
      let nameParts = this.$store.state.user.name.split(' ').map(part => part.trim()).filter(part => part);
      if (nameParts.length > 1) {
        for (let i = 0; i < 2; i++) {
          avatar += nameParts[i].substr(0, 1);
        }
      } else {
        avatar += nameParts[0].substr(0, nameParts[0].length > 1 ? 2 : 1);
      }
      return avatar.toUpperCase();
    },
    update() {
      window.location.reload();
    },
    pushWebNotification(data) {
      this.$notification.show(data && data.title ? data.title : this.$t('newNotification'), {
        body: data && data.content ? data.content : this.$t('newNotification'),
        vibrate: true
      }, {
        onclick: function () {
          if (data.target) {
            window.location = data.target;
          }
        }
      });
    },
    support() {
      window.open(`https://bit.ly/ttdh_bug_request`);
    }
  },
  created() {
    if (!this.$store.state.user.client.allowMultipleLogins) {
      this.$bgService.post('/profile/delete-token', {
        token: this.$store.state.token,
        inApp: this.$store.inApp ? '1' : null
      }).then((response) => {
        console.log('Delete other tokens: ' + response.data);
      }).catch(err => {
        console.log("Error while deleting tokens: " + err)
      });
    } else {
      console.log("Multiple logins allowed")
    }
  },
  mounted: function () {
    this.$bus.$on('pushWebNotification', this.pushWebNotification);

    let treeviewMenu = $('.app-menu');

    // Toggle Sidebar
    $('[data-toggle="sidebar"]').click(function (event) {
      event.preventDefault();
      $('.app').toggleClass('sidenav-toggled');
    });

    // Activate sidebar treeview toggle
    $("[data-toggle='treeview']").click(function (event) {
      event.preventDefault();
      if (!$(this).parent().hasClass('is-expanded')) {
        treeviewMenu.find("[data-toggle='treeview']").parent().removeClass('is-expanded');
      }
      $(this).parent().toggleClass('is-expanded');
    });

    // Set initial active toggle
    $("[data-toggle='treeview.'].is-expanded").parent().toggleClass('is-expanded');

    //Activate bootstrip tooltips
    $("[data-toggle='tooltip']").tooltip();

    // show search header
    $('.js-show-search').click(function (event) {
      event.preventDefault();
      $('.c-search').show();
    });

    //hide searh header
    $('.js-search-hide').click(function (event) {
      event.preventDefault();
      $('.c-search').hide();
    });

    //expand menu
    $('.js-menu-expand').on('click', function (e) {
      e.preventDefault();
      let menu = $('.c-menu');
      let parent = $(this).parent();
      if (menu.hasClass('has-menu-tiny')) {
        $(parent).removeClass('active');
        $(this).removeClass('active');
        menu.removeClass('has-menu-tiny')
            .slideUp();
      } else {
        $(parent).addClass('active');
        $(this).addClass('active');
        menu.addClass('has-menu-tiny')
            .slideDown();
      }
    });

    //expand submenu
    $('.btn-submenu').on('click', function (e) {
      e.preventDefault();
      let grand = $(this).parent().parent();
      let root = $(this).parent().parent().parent();
      if ($(grand).hasClass('active')) {
        $(grand).removeClass('active');
        $('>.dropdown-menu', $(grand)).slideUp();
      } else {
        $('li.active > .dropdown-menu', $(root)).slideUp();
        $('li.active', $(root)).removeClass('active');
        $(grand).addClass('active');
        $('>.dropdown-menu', $(grand)).slideDown();
      }
    });

    //close menu in mobile
    $('.c-menu a').on('click', function (e) {
      var menu = $('.c-menu');
      var viewportGlobal = $(window).width();
      if (e.target == this && viewportGlobal < 768) {
        menu.removeClass('has-menu-tiny')
            .slideUp();
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off('pushWebNotification');
  }
};
</script>
